import {useState} from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import {connect} from 'react-redux'

import useMediaQuery from '@mui/material/useMediaQuery'

import {clearFilter, initiateSearch} from '../../actions'


import Menu from '@mui/material/Menu'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Dialog from '@mui/material/Dialog'

import MapFilter from './MapFilter'
import FilterMenu from './FilterMenu'
import DateFilter from './DateFilter'
import TimeFilter from './TimeFilter'
import GenreFilter from './GenreFilter'
import PriceFilter from './PriceFilter'
import RadiusFilter from './RadiusFilter'


import {SlideTransition} from '../generics'



const cssStyles = ({isSmallScreen, isLessThanLargeScreen}) => ({
  root: css`
    z-index: 30;
    margin: 0;
    padding: ${isLessThanLargeScreen ? '5px 0px' : '10px'};
    background-color: ${isLessThanLargeScreen ? 'rgb(244, 245, 251)' : '#fff'};
    box-shadow: 1px 3px 10px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: ${isLessThanLargeScreen ? 'center' : 'flex-start'};
    margin-top: ${isLessThanLargeScreen ? '0px' : '5px'};

    .MuiTabs-root {
      min-height: 40px;
      align-items: center;
      position: relative;
    }

    .MuiTab-root {
      min-height: ${isSmallScreen ? '32px' : '32px'};
      max-height: ${isSmallScreen ? '32px' : '32px'};
      min-width: 40px;
      border-radius: 16px;
      padding: 7px 15px 7px 15px;
      font-size: 11px;

      svg {
        width: 15px;
      }
    }
    
    .MuiTabs-flexContainer {
      align-items: center;
      gap: 10px;
      padding: ${isLessThanLargeScreen ? '0px 20px' : null};

    }

    .MuiTabs-scrollButtons.Mui-disabled {
      opacity: 0;
    }

    .MuiTabScrollButton-horizontal {
      max-height: 30px;
      width: 30px;
      position: absolute;
      box-shadow: 1px 0px 3px rgba(0, 0, 0, 0.1);
      background-color: #fff;
      z-index: 20;
      opacity: 1;
      
      span {
        border-radius: 50%;
        // border: 1px solid #c4c4c4;
        background-color: #ffff;
      }

      svg {
        z-index: 10;
      }
    }

    .MuiTabScrollButton-horizontal:first-of-type {
      left: 0;
      border-top-right-radius: 50%;
      border-bottom-right-radius: 50%;
      height: 30px;
    }

    .MuiTabScrollButton-horizontal:last-of-type {
      right: 0px;
      border-top-left-radius: 50%;
      border-bottom-left-radius: 50%;
      height: 30px;
    }
  `,
  menu: css`
    .MuiMenu-paper {
      margin-top: 8px;
      max-width: 500px;
      box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px;
    }

    .MuiList-padding {
      padding-top: 0;
      padding-bottom: 0;
    }
  `
})



const filters = ['map', 'all', 'genres', 'date', 'time', 'price', 'distance', 'clear']



const FilterBar = props => {

  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'))
  const isLessThanLargeScreen = useMediaQuery(theme => theme.breakpoints.down('lg'))


  const styles = cssStyles({isSmallScreen, isLessThanLargeScreen})

  const [tab, setTab] = useState(0)

  const [menu, setMenu] = useState('')

  const [anchorEl, setAnchorEl] = useState(null)


  const {
    clearFilter, 
    initiateSearch,
    isRadiusFilterActive,
    isDateFilterActive,
    isTimeFilterActive,
    isPriceFilterActive,
    isGenreFilterActive
  } = props



  const open = type => e => {
    if (type === 'clear') {
      ['tags', 'date', 'time', 'price', 'radius'].forEach(filter => {
        clearFilter(filter.toUpperCase())
      })

      initiateSearch()
      return
    }

    setMenu(type)
    setAnchorEl(e.currentTarget)
  }


  function close() {
    setAnchorEl(null)
  }



  function handleChange(e, newValue) {
    setTab(newValue) 
  }



  function highlight(filter) {
    switch (filter) {
    case 'genres':
      return isGenreFilterActive
    case 'date':
      return isDateFilterActive
    case 'time':
      return isTimeFilterActive
    case 'price':
      return isPriceFilterActive
    case 'distance':
      return isRadiusFilterActive
    default:
      return false
    }
  }



  return (
    <div css={styles.root}>
      <Tabs
        value={tab}
        onChange={handleChange}
        variant='scrollable'
        scrollButtons='auto'
        TabIndicatorProps={{
          sx: {
            display: 'none'
          }
        }}
      >
        {filters.map(filter => (
          <Tab 
            key={filter}  
            label={filter.toUpperCase()}
            onClick={open(filter)}
            sx={{
              '&.MuiTab-root': {
                color: highlight(filter) ? '#fff' : '#000', 
                backgroundColor: highlight(filter) ? '#000' : isLessThanLargeScreen ? '#fff' : 'rgb(244, 245, 251)',
              }
            }}
          />
        ))}

        {isLessThanLargeScreen && 
          <Tab 
            sx={{
              width: '15px',
              height: '25px',
              visibility: 'hidden'
            }} 
          />
        }
      </Tabs>



      {isSmallScreen &&
        <Dialog 
          open={Boolean(anchorEl)} 
          onClose={close} 
          fullScreen={menu === 'all' || menu === 'genres'}
          fullWidth={true}
          maxWidth={false}
          TransitionComponent={SlideTransition}
          sx={{
            '& .MuiDialog-container': {
              alignItems: 'flex-end',  // Align dialog at the bottom of the screen
            },
            '& .MuiPaper-root': {
              borderTopLeftRadius: '8px',
              borderTopRightRadius: '8px',
              borderBottomLeftRadius: '0px',
              borderBottomRightRadius: '0px',
              overflowY: 'auto',
              margin: '0px',
              width: '100%',
              maxWidth: '100%'
            }
          }}
          BackdropProps={{
            style: {
              backdropFilter: 'blur(5px)',
              backgroundColor: 'rgba(0,0,0,0.5)'
            }
          }}
        >
          <div style={{width: '100%'}}>
            {(() => {
              switch (menu) {
              case 'map':
                return <MapFilter />
              case 'all':
                return <FilterMenu close={close} />
              case 'genres':
                return <GenreFilter close={close} />
              case 'date':
                return <DateFilter close={close} />
              case 'time':
                return <TimeFilter close={close} />
              case 'price':
                return <PriceFilter close={close} />
              case 'distance':
                return <RadiusFilter close={close} />
              default:
                return null
              }
            })()}
          </div>
        </Dialog>
      }


      {!isSmallScreen &&
        <Menu 
          css={styles.menu}
          anchorEl={anchorEl} 
          anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
          open={Boolean(anchorEl)}
          onClose={close}
        >
          <div>
            {(() => {
              switch (menu) {
              case 'map':
                return <MapFilter />
              case 'all':
                return <FilterMenu close={close} />
              case 'genres':
                return <GenreFilter close={close} />
              case 'date':
                return <DateFilter close={close} />
              case 'time':
                return <TimeFilter close={close} />
              case 'price':
                return <PriceFilter close={close} />
              case 'distance':
                return <RadiusFilter close={close} />
              default:
                return null
              }
            })()}
          </div>
        </Menu>
      }
    </div>
  )
}



const mapStateToProps = state => {
  return {
    isDateFilterActive: state.search.filters.time.isDateActive,
    isTimeFilterActive: state.search.filters.time.isTimeActive,
    isPriceFilterActive: state.search.filters.price.isActive,
    isGenreFilterActive: state.search.filters.tags !== '',
    isRadiusFilterActive: state.search.filters.location.isRadiusActive
  }
}



export default connect(mapStateToProps, {clearFilter, initiateSearch})(FilterBar)



